export default __webpack_public_path__ + "static/poster-98df18f0476732754cd8d94e2b06589c.png";